<template>
  <v-container fluid class="footer__navigation">
    <v-container :class="{ 'experience-editor-on': isExperienceEditor }">
      <v-row :class="isAuthenticated ? 'footer__row' : 'footer__row footer__row--sparse'">
        <v-col
          cols="12"
          :md="isAuthenticated ? 3 : 6"
          class="footer__column"
          :sm="isAuthenticated ? 12 : 6"
        >
          <sc-placeholder name="jssfootercolumnone" :rendering="rendering" />
        </v-col>
        <v-col cols="6" md="3" sm="4" class="footer__column" v-if="isAuthenticated || isExperienceEditor">
          <v-list flat :dark="true">
            <sc-placeholder name="jssfootercolumntwo" :rendering="rendering" />
          </v-list>
        </v-col>
        <v-col cols="6" md="3" sm="4" class="footer__column" v-if="isAuthenticated || isExperienceEditor">
          <v-list flat :dark="true">
            <sc-placeholder name="jssfootercolumnthree" :rendering="rendering" />
          </v-list>
        </v-col>
        <v-col
          cols="12"
          :md="isAuthenticated ? 3 : 6"
          :sm="isAuthenticated ? 4 : 6"
          class="footer__column"
        >
          <v-list flat :dark="true">
            <sc-placeholder name="jssfootercolumnfour" :rendering="rendering" />
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'FooterNavigation',
  data() {
    return {
      isAuthenticated: false,
    };
  },
  mounted: async function() {
    this.isAuthenticated = await this.$auth.isAuthenticated() && this.$auth.userDetails && this.$auth.userDetails.hasAgreedChallengerTerms;
  },
  props: {
    rendering: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    isExperienceEditor() {
      return isExperienceEditorActive();
    },
  },
  components: {
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss">
.experience-editor-on .scEmptyPlaceholder {
  width: 100px;
  height: 50px;
}
.footer__navigation .footer__column {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding-top: 0;
    padding-bottom: 0;

    .v-list-item {
      padding: 0;
    }
  }
}

.footer__navigation .footer__row--sparse {
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    justify-content: space-between;

    .footer__column {
      width: auto;
      flex-basis: auto;
    }
  }
}
</style>
<style lang="scss" scoped>
.footer__navigation {
  border-bottom: 1px solid map-deep-get($colors, 'grey-dark', 'base');
  padding: 0;
}

.v-list {
  &::v-deep {
    .v-list-item {
      min-height: 56px;
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0;
  }
}
</style>
